import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { AuthService } from '@app/auth/auth.service';
import { NavbarService } from '@app/navbar/navbar.service';
import { Observable } from 'rxjs';
import { UtilService } from '@app/shared/services/util.service';

var username:any
 @Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.css'],
    standalone: false
})
export class NavbarComponent implements OnInit {
  isLoggedIn$: Observable<boolean>;
  username:any

  constructor(
    private route: Router,
    private authService: AuthService,
    public nav: NavbarService,
    private util: UtilService
  ) { }

  ngOnInit(): void {
    
    this.isLoggedIn$ = this.authService.isLoggedIn;

    $( ".nav-item" ).on( "click", function() {
      //event.preventDefault();
      var clickedItem = $(this);
      $( ".nav-item" ).each( function() {
          $(this).removeClass( "active" );
      });
      clickedItem.addClass( "active" );
      
  });
  }

  navbarLogic(username:any){
    if(username=='admin'){
      var navbar1 = document.getElementById('adminNav');
      navbar1.style.display = 'flex';
    }
    else if(username=='sales'){
      var navbar2 = document.getElementById('salesNav');
      navbar2.style.display = 'flex';
    }

  }

  onLogout() {
    this.authService.logout();
  }

  logout(){
    this.util.clearStoragePreservingTableColumnPreferences();
    this.route.navigate(['/']);
  }

}
